<script setup lang="ts">
import type { InputValidation } from '@shared/validation'
import { isValidUsPhoneNumber } from '@consumer/services/validation'

const isOlderThanToday: InputValidation = {
  isValueValid: date => !date || new Date(date) < new Date(),
  errorMessage: () => 'Please enter a valid birthday.',
}
</script>

<template>
  <GInput
    field="firstName"
    placeholder="Enter Your First Name"
    required
  />
  <GInput
    field="lastName"
    placeholder="Enter Your Last Name"
    required
  />
  <GInput
    v-mask="'####-##-##'"
    placeholder="ex: 2000-05-11"
    field="birthday"
    :validate="isOlderThanToday"
    required
    hint="Enter in the following format: YYYY-MM-DD"
  />
  <GInput
    v-mask="'(###) ###-####'"
    field="phoneNumber"
    placeholder="ex: (555) 444-4444"
    :validate="isValidUsPhoneNumber"
    required
  />
</template>
